export function formatExperimentLatency(seconds: number | null) {
  if (seconds == null) return "—"
  return `${seconds.toFixed(1)}s`
}
